module.exports = __webpack_public_path__ + "static/media/ghee-vanaspati.1fd8038a.webp";